import useMediaQuery from './useMediaQuery';

// Single JS source of truth for the desktop breakpoint. Must match
// $screenlg in src/styles/_breakpoints.sass (and @screen-lg in overrides.less).
export const DESKTOP_MEDIA_QUERY = '(min-width: 992px)';

const useIsDesktop = () => useMediaQuery(DESKTOP_MEDIA_QUERY);

export default useIsDesktop;
